import axiosInstance from '../services/AxiosInstance';

export function getAmenity(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`amenity?pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}`);
}

export function deleteAmenity(id) {
    return axiosInstance.delete(`amenity/${id}`);
}

export function createAmenity(id) {
    return axiosInstance.post(`amenity`,id);
}

export function updateAmenity(id, data) {
    return axiosInstance.put(`amenity/${id}`,data);
}
